module.exports = __webpack_public_path__ + "img/down_jian.12445df3.svg";